import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import classes from "./UIStyles.module.scss"
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useTranslation } from 'react-i18next';

const ModalWindow = (props) => {
  const {t} = useTranslation();
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      {...props}
    >
      <Modal.Header className={classes.modalHeader}>
        <div className='w-100 d-flex '>
            <div>
              <PersonAddIcon style={{fontSize:"2.2rem", marginRight:"1rem"}}/>
              <span className={classes.modalTitleText}>{t("Add customer")}</span>
            </div>
            <div className="ms-auto">
              <HighlightOffIcon style={{fontSize:"2rem", cursor:"pointer"}} onClick={props.onHide}/>
            </div>
          </div>
       {/*  <Modal.Title id="contained-modal-title-vcenter">
          
          <PersonAddIcon style={{fontSize:"2rem", marginRight:"1rem"}}/>
          Add customer
          <div style={{display:"inline", marginLeft:"auto"}}>sss</div>
        </Modal.Title> */}
      </Modal.Header>
      <Modal.Body className={classes.modalBody}>
        {props.children}
      </Modal.Body>
{/*       <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
}

export default ModalWindow;

